// extracted by mini-css-extract-plugin
export var currencyInput = "_o0-1";
export var currencySymbol = "_o0-0";